import { PaintBrushIcon } from "@heroicons/react/24/outline";
import moment from "moment";

const conditionStatusStyles = Object.freeze({
  cancelled: "bg-gray-100 text-gray-700",
  destroyed: "bg-gray-800 text-white",
  fair: "bg-amber-100 text-amber-800",
  good: "bg-emerald-100 text-emerald-800",
  "not available": "bg-gray-100 text-gray-700",
  "not studio approved": "bg-red-100 text-red-800",
  pending: "bg-blue-100 text-blue-800",
  poor: "bg-red-100 text-red-800",
  restoration: "bg-orange-100 text-orange-800",
  "studio approved": "bg-emerald-100 text-emerald-800",
  unchecked: "bg-gray-100 text-gray-700",
});

const getConditionStatusStyle = description =>
  conditionStatusStyles[description?.trim().toLowerCase()] ||
  "bg-gray-100 text-gray-700";

const formatLastCheckedDate = condition => {
  const date = condition?.date || condition?.time;
  return date && moment.parseZone(date).isValid()
    ? moment.parseZone(date).format("D MMM YYYY")
    : "Not recorded";
};

const InstanceConditionStatus = ({ condition }) => {
  const description = condition?.status?.description || "Not recorded";
  const lastCheckedDate = formatLastCheckedDate(condition);

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium ${getConditionStatusStyle(
        description,
      )}`}
      title={`Work condition: ${description}\nLast checked: ${lastCheckedDate}`}
    >
      <PaintBrushIcon className="h-3.5 w-3.5" />
      <span className="font-bold">Condition</span>
      <span>{description}</span>
    </span>
  );
};

export { formatLastCheckedDate, getConditionStatusStyle };
export default InstanceConditionStatus;
